import React from "react";
import styled from "styled-components";
import { Box, LazyImage, SpanStyled, TextStyled } from "../../styled/Elements";

const CheckboxBtn = ({
  label,
  value,
  checked,
  onChange,
  name,
  subLabel,
  avatar,
  className,
  register,
  validationRules,
  onClick,
  disabled,
  padding,
  size,
}) => {
  return (
    <CheckboxWrapper
      padding={padding}
      className={className}
      subLabel={subLabel}
      checked={checked}
    >
      <input
        className="checkbox-input"
        type="checkbox"
        name={name}
        value={value}
        checked={checked}
        onChange={onChange}
        onClick={onClick}
        disabled={disabled}
        {...(register && register(name, validationRules))}
      />
      <Box className="d-flex align-items-center gap-2">
        {avatar && (
          <Box>
            <LazyImage src={avatar} />
          </Box>
        )}
        <Box>
          {label && (
            <SpanStyled
              size={size ? size : "16px"}
              color="var(--text)"
              className="checkbox-label"
              checked={checked}
            >
              {label}
            </SpanStyled>
          )}
          {subLabel && (
            <TextStyled
              size="14px"
              weight="300"
              color="var(--text2)"
              className="checkbox-sublabel"
              checked={checked}
            >
              {subLabel}
            </TextStyled>
          )}
        </Box>
      </Box>
    </CheckboxWrapper>
  );
};

export default CheckboxBtn;

const CheckboxWrapper = styled.label`
  display: flex;
  align-items: ${({ subLabel }) => (!subLabel ? "center" : "flex-start")};
  gap: 15px;
  width: fit-content;
  padding: ${({ padding }) => (padding ? padding : "11px 15px")};
  border-radius: 10px;
  cursor: pointer;
  transition: all 0.3s ease;
  background-color: var(--white);
  border: 1px solid
    ${({ checked }) => (checked ? "var(--themeColor2)" : "var(--border)")};

  .checkbox-input {
    appearance: none;
    width: 22px;
    height: 22px;
    border: 2px solid var(--border);
    border-radius: 5px;
    background-color: var(--bgSecondary);
    position: relative;
    transition: all 0.2s ease;

    &:checked {
      border-color: var(--themeColor2);
      background-color: var(--themeColor2);
    }

    &:checked::after {
      content: "✓";
      color: white;
      font-size: 14px;
      font-weight: bold;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }

    &:checked + div .checkbox-label {
      color: var(--themeColor2);
      font-weight: 600;
    }

    &:checked + div .checkbox-sublabel {
      color: var(--themeColor2);
    }
  }

  .checkbox-label {
    color: ${({ checked }) =>
      checked ? "var(--themeColor2)" : "var(--text)"};
    font-weight: ${({ checked }) => (checked ? 600 : 400)};
  }

  .checkbox-sublabel {
    color: ${({ checked }) =>
      checked ? "var(--themeColor2)" : "var(--text2)"};
  }

  @media (max-width: 530px) {
    padding: 5px;
  }
`;
